import { Injectable } from '@angular/core';
import { Recipient } from '@aptitude/shared';
import { BehaviorSubject } from 'rxjs';

@Injectable()
export class ResponseNavService {
  #loadingIndicator$ = new BehaviorSubject(false);
  loadingIndicator$ = this.#loadingIndicator$.asObservable();
  private _recipientData$ = new BehaviorSubject<Array<Recipient>>([]);
  recipientData$ = this._recipientData$.asObservable();

  setLoadingIndicator(value: boolean) {
    this.#loadingIndicator$.next(value);
  }

  setRecipientData(recipient: Array<Recipient>) {
    this._recipientData$.next(recipient);
  }
}
